/**
 * @generated SignedSource<<bc752aafaf4f8ab059324351bee2b362>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueBodyViewerPinnedCommentSecondary$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PinnedCommentDisplaySecondary">;
  readonly " $fragmentType": "IssueBodyViewerPinnedCommentSecondary";
};
export type IssueBodyViewerPinnedCommentSecondary$key = {
  readonly " $data"?: IssueBodyViewerPinnedCommentSecondary$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueBodyViewerPinnedCommentSecondary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueBodyViewerPinnedCommentSecondary",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PinnedCommentDisplaySecondary"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "e72fbc0492a61f5cf5058e65520bd6f3";

export default node;
